import { z } from 'zod';
/**
 * Leaf module for the shared LoggedInUser aggregate-counts schema (KIR-2916).
 *
 * It deliberately imports nothing but `zod` so it can be referenced by both
 * `shadow-ai.ts` and the per-surface list-item contracts
 * (`shadow-ai-installed-tools.ts`, `shadow-ai-browser-tools.ts`) without
 * creating an import cycle. `shadow-ai.ts` re-exports these for convenience.
 */
/**
 * Per-tool aggregate counts of distinct users by LoggedInUser match, shown as
 * chips on the parent tool row. `unknown` users are the implicit remainder and
 * are not chipped.
 */
export const loggedInUserCountsSchema = z.object({
    matched: z.number().int().min(0),
    corporate: z.number().int().min(0),
    personal: z.number().int().min(0),
});
/**
 * Backend-computed relationship between a detection's LoggedInUser email and the
 * Kirin user it is attributed to:
 * - `matched`   — same email (case-insensitive, +alias-normalised)
 * - `corporate` — different local-part, same domain
 * - `personal`  — different domain
 * - `unknown`   — no LoggedInUser email available
 */
export const loggedInUserMatchSchema = z.enum([
    'matched',
    'corporate',
    'personal',
    'unknown',
]);
//# sourceMappingURL=shadow-ai-logged-in-user.js.map